import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface ErrorIcon extends SVGProps<SVGSVGElement> {
  label?: string
}

const ErrorIcon: React.FC<ErrorIcon> = ({ label = 'error', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        data-testid="error-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...restProps}>
        <path
          d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default ErrorIcon
